import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Router, IndexRoute, Route, IndexRedirect } from 'react-router'
import CoreLayout from './components/CoreLayout'
import './index.css'

// import configureStore from './store/configureStore'

// import Root from 'containers/Root'


import "./styles/base.css"

if (module.hot) {
    module.hot.accept()
}


if (__DEV__ && !document.documentElement.animate) {
    // Add a polyfill for Element.animate so that the React render visualizer
    // plugin will work okay in all browsers (namely, Firefox)
    require('web-animations-js')
}


import store, { history } from './store'

// window.React = React

const rootEl = document.getElementById("root")



let render = () => {
    // const Root = require("containers/Root").default
    ReactDOM.render(
        <Provider store={store}>
          <Router history={history}>
            <Route path="/" component={CoreLayout}>
            </Route>
          </Router>
        </Provider>,
        rootEl
    )
}
              // <IndexRedirect to="/de" />
              // <Route path="/de">
              //   <IndexRedirect to="/de/1" />
              //   <Route path="/:lang/:step(/:postalCode)" component={App}>
              //     <IndexRoute component={Regions} />
              //     <Route path="*" component={NotFound} />
              //   </Route>
              // </Route>
              // <Route path="/:lang(/:step(/:postalCode))" component={App}>
              //   <IndexRoute component={Regions} />
              //   <Route path="*" component={NotFound} />
              // </Route>


if(module.hot) {
    // Support hot reloading of components
    // and display an overlay for runtime errors
    const renderApp = render
    const renderError = (error) => {
        const RedBox = require('redbox-react')
        ReactDOM.render(
            <RedBox error={error} />,
            rootEl,
        )
    }

    render = () => {
        try {
            renderApp()
        }
        catch(error) {
            renderError(error)
        }
    }

    module.hot.accept('./components/CoreLayout', () => {
        setTimeout(render)
    })
}
// prevent pinch-to-zoom
document.addEventListener('touchmove', function(event) {
  event = event.originalEvent || event;
  if(event.scale != 1) {
    event.preventDefault();
  }
}, false);
// prevent double-tap-to-zoom
var lastTouchEnd = 0;
document.addEventListener('touchend', function (event) {
  var now = (new Date()).getTime();
  if (now - lastTouchEnd <= 300) {
    event.preventDefault();
  }
  lastTouchEnd = now;
}, false);

render()


// WEBPACK FOOTER //
// ./src/index.js